import React, { useState, useEffect, useRef } from "react";

import axios from "axios";
import { Mensaje, MensajeSiNo } from "../mensajes2";
import { Dimmer } from "../spinner";
import {
  formatMoneda,
  validaSoloNumero,
  validaMonto,
  cmes,
} from "../../util/varios";
import useTable from "../useTable";
import CatalogoCuentaBancaria from "../../catalogos/catalogoCuentaBancarias";
import CatalogoSaldoBanco from "../../catalogos/catalogoSaldoBanco";
import { SearchInput, Input, Select } from "../../ui/inputs/Input";
import {
  DangerButton,
  InfoButton,
  PrimaryButton,
  SuccessButton,
  WarningButton,
} from "../../ui/buttons/Button";

const TablaSaldpEstadoCuenta = (props) => {
  const headCells = [
    {
      id: "codigo",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "CUENTA",
      textAlign: "center",
    },
    {
      id: "nombre",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "DESCRIPCIÓN",
      textAlign: "center",
    },
    {
      id: "rif",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "DEBE",
      textAlign: "center",
    },
    {
      id: "nrolicencia",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "HABER",
      textAlign: "center",
    },
    {
      id: "opciones",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: " OPCIONES",
      textAlign: "center",
    },
  ];

  var op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const txtDebe = useRef();
  const txtHaber = useRef();
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const cmbMes = useRef();
  const cmbAniio = useRef();
  const txtMonto = useRef();
  const txtId = useRef();
  const txtId2 = useRef();

  const txtCuenta = useRef();
  const txtOtroPorcen = useRef();
  const [operacion, setOperacion] = useState(0);
  const [cuentaContable] = useState();
  const [records, setRecords] = useState([]);
  const [filterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [visibleBtn, setVisibleBtn] = useState("visible");
  const [visibleId, setVisibleId] = useState("visible");
  const [visibleOtro, setVisibleOtro] = useState("collapse");
  const [visibleISLR, setVisibleISLR] = useState("hidden");
  const [tituloHeader, setTituloHeader] = useState(
    "Gestionar Saldo Estado de Cuenta."
  );
  const [habilitado, setHabilitado] = useState(true);
  const [catalogoCuenta, setCatalogoCuenta] = useState(false);
  const [cmbAnio, setCmbAnio] = useState(false);
  const [tablaCata, setTablaCata] = useState(0);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [catalogoAsi, setCatalogoAsi] = useState(false);

  const [botones, setBotones] = useState({
    incluir: false,
    consultar: false,
    modificar: false,
    eliminar: false,
    aceptar: true,
    cancelar: true,
    catalogo: true,
    catalogoBene: true,
  });
  const [values, setValues] = useState({
    codigocuenta: "",
    debe: "",
    descripcion: "",
    haber: "",
    idplancuenta: "",
    idcuentacontable: "",
    tipo: 0,
  });

  const {} = useTable(records, headCells, filterFn);
  const [habilitadoNU, setHabilitadoNU] = useState(true);
  const blanquear = () => {
    setRecords("");
    txtId.current.setAttribute("disabled", true);
    txtId2.current.setAttribute("disabled", true);
    txtCuenta.current.value = "";
    txtId.current.value = "";
    txtId2.current.value = "";
    cmbMes.current.value = "";
    cmbAniio.current.value = "";
    txtMonto.current.value = "";

    setOperacion(0);
    setTituloHeader("Gestionar Saldo Estado de Cuenta.");
    setVisibleISLR("hidden");
    setVisibleOtro("collapse");
    setVisibleBtn("visible");
    setVisibleId("visible");
    setValues({
      codigocuenta: "",
      debe: "",
      descripcion: "",
      haber: "",
      idplancuenta: "",
      idcuentacontable: "",
      tipo: 0,
    });
    setBotones({
      incluir: false,
      consultar: false,
      modificar: false,
      eliminar: false,
      aceptar: true,
      cancelar: true,
      catalogo: true,
      catalogoBene: true,
    });

    txtId.current.value = "";
    setActivate(false);
    setHabilitado(true);
    setHabilitadoNU(true);
  };

  const procesarRegistro = () => {
    setActivate(true);
    let ope = 0;
    if (!botones.incluir) {
      ope = 1;
    } else if (!botones.modificar) {
      ope = 2;
    } else if (!botones.eliminar) {
      ope = 3;
    }
    let endpoint = `${op.conexion}/api/contabilidadfis/saldobanco`;
    let body;
    body = {
      operacion: ope,
      nid: txtId.current.value,
      idcuenta: txtId2.current.value,
      nmes: cmbMes.current.value,
      nommes: cmes(cmbMes.current.value),
      nanio: cmbAniio.current.value,
      nsaldo: txtMonto.current.value.replace(/\./g, "").replace(",", "."),
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (ope === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro creado correctamente",
              icono: "exito",
            });
          } else if (ope === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro modificado correctamente",
              icono: "exito",
            });
          } else if (ope === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro eliminado correctamente",
              icono: "exito",
            });
          }
          blanquear();
          setActivate(false);
        }
      })
      .catch(function (error) {
        let mensaje = "";
        if (error.response === undefined) {
          mensaje = "Error de Conexion";
        } else {
          if (
            error.response.data.message ===
            'duplicate key value violates unique constraint "ubicacion_key"'
          ) {
            mensaje = "Ya existe un Registro";
          } else {
            mensaje = error.response.data.message;
          }
        }
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const handleCloseSi = () => {
    setActivate(false);
    if (mensajesino.texto === "Desea Eliminar Esta Cuenta de la Lista.") {
      let array2 = [];
      for (let i = 0; i < records.length; i++) {
        if (
          parseInt(records[i].idplancuenta) !==
          parseInt(cuentaContable.idplancuenta)
        ) {
          array2.push(records[i]);
        }
      }
      setRecords(array2);
      let debe = 0;
      let haber = 0;
      for (let i = 0; i < array2.length; i++) {
        debe = parseFloat(debe) + parseFloat(array2[i].debe.toString());
        haber = parseFloat(haber) + parseFloat(array2[i].haber.toString());
      }
      txtDebe.current.value = formatMoneda(
        debe.toString().replace(",", "").replace(".", ","),
        ",",
        ".",
        2
      );
      txtHaber.current.value = formatMoneda(
        haber.toString().replace(",", "").replace(".", ","),
        ",",
        ".",
        2
      );
    } else {
      procesarRegistro();
    }
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const onChange = (event) => {
    if (event.target.name === "descripcion") {
      event.target.value = event.target.value;
      setValues({ ...values, [event.target.name]: event.target.value });
    } else if (event.target.name === "unidad") {
      if (event.target.value === "4") {
        setVisibleOtro("visible");
      } else {
        setVisibleOtro("collapse");
        txtOtroPorcen.current.value = "";
      }
      setValues({ ...values, [event.target.name]: event.target.value });
    } else if (event.target.name === "tipo") {
      setValues({ ...values, [event.target.name]: event.target.value });
    } else if (event.target.name === "tipoasiento") {
      setTablaCata(event.target.value);
    } else {
      setValues({ ...values, [event.target.name]: event.target.value });
    }
  };

  const onChangeValidar = () => {
    let sigue = true;
    if (!botones.incluir || !botones.modificar) {
      if (txtId.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Ingresar el Codigo de un saldo.",
          icono: "informacion",
        });
        sigue = false;
        txtId.current.focus();
      } else if (txtId2.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Ingresar la cuenta bancaria.",
          icono: "informacion",
        });
        sigue = false;
        txtId2.current.focus();
      } else if (cmbMes.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe seleccionar un mes.",
          icono: "informacion",
        });
        sigue = false;
        cmbMes.current.focus();
      } else if (cmbAniio.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe seleccionar un año.",
          icono: "informacion",
        });
        sigue = false;
        cmbAniio.current.focus();
      } else if (txtMonto.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe seleccionar un Monto.",
          icono: "informacion",
        });
        sigue = false;
        txtMonto.current.focus();
      }
    }
    if (sigue) {
      let msg = "";
      if (!botones.incluir) {
        msg = "Esta Seguro de Registrar estos Datos.";
      } else if (!botones.modificar) {
        msg = "Esta Seguro de Modificar estos Datos.";
      } else if (!botones.eliminar) {
        msg = "Esta Seguro de Eliminar estos Datos.";
      }
      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const onBotones = (op) => (e) => {
    setOperacion(op);
    if (op === 1 || op === 2 || op === 3 || op === 4) {
      setVisibleBtn("hidden");
    } else if (op === 6) {
      setVisibleBtn("visible");
    }
    e.preventDefault();
    if (op === 1) {
      setVisibleId("collapse");
      setTituloHeader("Incluir Saldo Estado de Cuenta.");
      setHabilitado(false);
      setBotones({
        incluir: false,
        consultar: true,
        modificar: true,
        eliminar: true,
        aceptar: false,
        cancelar: false,
        catalogo: true,
        catalogoBene: false,
      });
    } else if (op === 2) {
      setTituloHeader("Editar Saldo Estado de Cuenta.");
      txtId.current.removeAttribute("disabled");
      txtId.current.focus();
      setHabilitado(false);
      setBotones({
        incluir: true,
        consultar: true,
        modificar: false,
        eliminar: true,
        aceptar: false,
        cancelar: false,
        catalogo: false,
        catalogoBene: true,
      });
    } else if (op === 3) {
      setTituloHeader("Eliminar Saldo Estado de Cuenta.");
      setHabilitado(true);
      setBotones({
        incluir: true,
        consultar: true,
        modificar: true,
        eliminar: false,
        aceptar: false,
        cancelar: false,
        catalogo: false,
        catalogoBene: true,
      });
      txtId.current.removeAttribute("disabled");
      txtId2.current.removeAttribute("disabled");
      txtId.current.focus();
    } else if (op === 4) {
      setTituloHeader("Consultar Saldo Estado de Cuenta.");
      setHabilitado(true);
      txtId.current.focus();
      setBotones({
        incluir: true,
        consultar: false,
        modificar: true,
        eliminar: true,
        aceptar: true,
        cancelar: false,
        catalogo: false,
        catalogoBene: true,
      });
      txtId.current.removeAttribute("disabled");
      txtId2.current.removeAttribute("disabled");
      txtId.current.focus();
    } else if (op === 5) {
      onChangeValidar();
    } else if (op === 6) {
      blanquear();
    }
  };

  useEffect(() => {
    const anioactu = JSON.parse(localStorage.getItem("anioactu"));
    const anios = [];
    for (let i = 0; i < 7; i++) {
      let anioa = parseInt(anioactu) - i;
      anios.push({
        anio: anioa,
      });
    }
    setCmbAnio(anios);
  }, []);

  const handleInputMonto = (event) => {
    validaMonto(event);
    if (
      event.target.value === "" ||
      parseFloat(
        event.target.value.trim().replace(/\./g, "").replace(",", ".")
      ) === 0.0
    ) {
      event.target.value = "0,00";
    }
    if (event.which === 13 || typeof event.which === "undefined") {
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.legth
        );
      }
      console.log(event.target.value);
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const seleccionarCuentaBancaria = (id) => {
    let campos = "*";
    let nomtab = "cuentabancaria";
    let nomid = "idcuentabancaria";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid} `;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data !== "") {
            txtId2.current.value = response.data.idcuentabancaria;
            txtCuenta.current.value =
              response.data.nombre.trim() +
              " --- " +
              response.data.cuentabancaria.trim();
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const validarCuentaB = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarCuentaBancaria(event.target.value);
      } else {
      }
    }
  };

  const validarCatalogo = (values) => {
    setCatalogoCuenta(false);
    seleccionarCuentaBancaria(values.idcuentabancaria);
  };

  const seleccionarSaldoBanco = (id) => {
    setCatalogoAsi(false);
    console.log(id);
    let campos = "*";
    let nomtab = "saldobanco";
    let nomid = "idsaldobanco";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid} `;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          console.log(response.data);

          txtId.current.value = response.data.idsaldobanco;
          cmbAniio.current.value = response.data.anio;
          cmbMes.current.value = response.data.mes;
          txtMonto.current.value = formatMoneda(
            response.data.saldo.toString().replace(".", ","),
            ",",
            ".",
            2
          );
          seleccionarCuentaBancaria(response.data.idcuentabancaria);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const validarCuenta = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarSaldoBanco(event.target.value);
      } else {
      }
    }
  };

  const exitHandler = () => {
    props.setTabla(0);
  };
  return (
    <div className="col-8 m-0 p-2 border rounded">
      <header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top">
        <h3 className="fw-bold m-0">{tituloHeader}</h3>
        <a href="#" onClick={exitHandler} className="fw-bold fs-6 text-light">
          Salir <i className="fas fa-times ms-2"></i>
        </a>
      </header>
      <div className="col-12 m-0 p-0 d-flex flex-wrap">
        <div className="col-4 m-0 my-2 p-0 " style={{ visibility: visibleId }}>
          <SearchInput
            label="Código:"
            onKeyUp={validarCuenta}
            onBlur={validarCuenta}
            name="idasiento"
            disabled
            onChange={onChange}
            onClickButton={() => {
              setCatalogoAsi(true);
            }}
            disabledButton={operacion === 0 ? true : false}
            ref={txtId}
          />
        </div>
        <fieldset className="col-12 m-0 mb-2 p-2 d-flex border-azul rounded">
          <legend className="float-none w-auto m-0">
            Datos de la Cuenta Bancaria
          </legend>
          <div className="col-4 m-0 p-0">
            <SearchInput
              label="Código:"
              name="idasiento"
              onChange={onChange}
              disabled={operacion === 1 ? false : operacion == 2 ? false : true}
              onKeyUp={validarCuentaB}
              onBlur={validarCuentaB}
              onClickButton={() => {
                setCatalogoCuenta(true);
              }}
              disabledButton={botones.catalogo}
              ref={txtId2}
            />
          </div>
          <Input
            name="idasiento"
            disabled
            onChange={onChange}
            ref={txtCuenta}
          />
        </fieldset>
        <div className="col-4 m-0 mb-2 p-0">
          <Select
            label="Mes:"
            name="tipo"
            disabled={operacion === 1 ? false : operacion == 2 ? false : true}
            id="tipo"
            onChange={onChange}
            ref={cmbMes}
          >
            <option value="0">seleccionar</option>
            <option value="1">ENERO</option>
            <option value="2">FEBRERO</option>
            <option value="3">MARZO</option>
            <option value="4">ABRIL</option>
            <option value="5">MAYO</option>
            <option value="6">JUNIO</option>
            <option value="7">JULIO</option>
            <option value="8">AGOSTO</option>
            <option value="9">SEPTIEMBRE</option>
            <option value="10">OCTUBRE</option>
            <option value="11">NOVIEMBRE</option>
            <option value="12">DICIEMBRE</option>
          </Select>
        </div>
        <div className="col-4 m-0 mb-2 p-0 pl-2">
          <Select
            label="Año:"
            name="tipo"
            disabled={operacion === 1 ? false : operacion == 2 ? false : true}
            id="tipo"
            onChange={onChange}
            ref={cmbAniio}
          >
            <option value="">Seleccionar</option>
            {cmbAnio &&
              cmbAnio.map((a) => (
                <option key={a.anio} value={a.anio}>
                  {a.anio}
                </option>
              ))}
          </Select>
        </div>
        <div className="col-4 m-0 mb-2 p-0 pl-2">
          <Input
            label="Saldo:"
            name="idasiento"
            disabled={operacion === 1 ? false : operacion == 2 ? false : true}
            onChange={handleInputMonto}
            ref={txtMonto}
          />
        </div>
      </div>

      {visibleBtn === "visible" && (
        <div className="col-12 m-0 mt-2 p-0 d-flex justify-content-end gap-2">
          <PrimaryButton
            icon="fa-plus"
            disabled={botones.incluir}
            onClick={onBotones(1)}
          >
            Incluir
          </PrimaryButton>
          <InfoButton
            icon="fa-eye"
            disabled={botones.consultar}
            onClick={onBotones(4)}
          >
            Consultar
          </InfoButton>
          <WarningButton
            icon="fa-edit"
            disabled={botones.modificar}
            onClick={onBotones(2)}
          >
            Modificar
          </WarningButton>
          <DangerButton
            icon="fa-trash-alt"
            disabled={botones.eliminar}
            onClick={onBotones(3)}
          >
            Eliminar
          </DangerButton>
        </div>
      )}
      <div
        className="col-12 m-0 p-0 d-flex justify-content-end gap-2"
        style={{
          visibility: visibleBtn === "visible" ? "collapse" : "visible",
        }}
      >
        <SuccessButton
          disabled={botones.aceptar}
          onClick={onBotones(5)}
          ref={btnAcepta}
        >
          Aceptar
        </SuccessButton>
        <DangerButton
          disabled={botones.cancelar}
          onClick={onBotones(6)}
          ref={btnCancela}
        >
          Cancelar
        </DangerButton>
      </div>

      <CatalogoCuentaBancaria
        show={catalogoCuenta}
        onHideCancelar={() => {
          setCatalogoCuenta(false);
        }}
        onHideAceptaCatalogo={validarCatalogo}
      />

      <CatalogoSaldoBanco
        show={catalogoAsi}
        onHideCancelar={() => {
          setCatalogoAsi(false);
        }}
        onHideAceptaCatalogo={seleccionarSaldoBanco}
      />

      <Dimmer active={activate} inverted></Dimmer>
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </div>
  );
};
export default TablaSaldpEstadoCuenta;
